<div class="checkbox-list-wrapper" [attr.title]="title" >
  <div class="checkbox" *ngFor="let option of options">
    <input
      type="checkbox"    
      [id]="`'${id}-${option.value}'`"
      [name]="name"      
      [title]="option.label"      
      [checked]="selectedValues.includes(option.value)"
      (change)="onCheckboxChange($event, option.value)"
    />
    <label [for]="`'${id}-${option.value}'`" >{{ option.label }}</label>
  </div>
</div>
<!-- <div class="checkbox">
  <input id="checkbox5" type="checkbox" checked="">
  <label for="checkbox5">
    CB1
  </label>
</div>
<div class="checkbox">
  <input id="checkbox6" type="checkbox" checked="">
  <label for="checkbox6">
    CB2
  </label>
</div> -->
